var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown-editor',{ref:"vditor",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"toolbar":_vm.toolbar},on:{"typing":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }